import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("pawtrek_user") || "null"); }
    catch { return null; }
  });
  const [ready, setReady] = useState(false);

  useEffect(() => {
    // CRITICAL: If returning from Google OAuth (session_id in URL hash),
    // skip the /me check — AuthCallback will exchange first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    const token = localStorage.getItem("pawtrek_token");
    const cachedUser = localStorage.getItem("pawtrek_user");
    if (!token && !cachedUser) { setReady(true); return; }
    api.get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        localStorage.setItem("pawtrek_user", JSON.stringify(data));
      })
      .catch(() => {
        localStorage.removeItem("pawtrek_token");
        localStorage.removeItem("pawtrek_user");
        setUser(null);
      })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("pawtrek_token", data.token);
    localStorage.setItem("pawtrek_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("pawtrek_token", data.token);
    localStorage.setItem("pawtrek_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); }
    catch (e) { console.error("Logout call failed (clearing local session anyway)", e); }
    localStorage.removeItem("pawtrek_token");
    localStorage.removeItem("pawtrek_user");
    setUser(null);
  };

  const setSessionUser = (u) => {
    localStorage.setItem("pawtrek_user", JSON.stringify(u));
    setUser(u);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, register, logout, setSessionUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
